import { Button, buttonStyles } from '@/shell/ui/button';
import { InternalLink } from '@/shell/ui/internal-link';

export type EmptyAction = { label: string } & ({ onClick: () => void } | { href: string });

export type EmptyStateProps = {
  /** Ein Satz, der sagt, was fehlt und worum es geht. */
  message: string;
  /** Genau eine nächste Handlung. */
  action?: EmptyAction;
};

/** Leerzustand: ein Satz und eine Aktion; ein leerer Bildschirm ist eine Einladung zum Handeln. */
export function EmptyState({ message, action }: EmptyStateProps) {
  return (
    <div className="grid justify-items-start gap-3 rounded-surface bg-surface-sunken p-5">
      <p className="max-w-[60ch] text-body text-ink">{message}</p>
      {action === undefined ? null : 'href' in action ? (
        <InternalLink href={action.href} className={buttonStyles({ variant: 'primary' })}>
          {action.label}
        </InternalLink>
      ) : (
        <Button variant="primary" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
